import React, { useEffect, useMemo, useState } from 'react';
import PhysicianWelcomeScreen from '@medflex/components/stories/PhysicianWelcomeScreen';
import { trackEvent } from '@medflex/utils/Tracking';
import useUserProfile from '../../hooks/useUserProfile';
import useAddressBookContacts from '../../hooks/useAddressBookContacts';
import { DEMO_BOOKING_URL } from '../../constants';
import useSubscription from '../../hooks/useSubscription';

const DemoBox = () => {
  const { userProfile, update, isLoadingUserProfile } = useUserProfile();
  const { isBasicUser } = useSubscription();
  const { pairedPatients, pairedPhysicians, support } = useAddressBookContacts();
  const {
    demoBoxHidden: demoBoxHiddenProfile,
    fullNameWithTitle,
    activity,
    postalCode,
    email,
    lastName,
    workplace,
  } = userProfile.attributes;
  const [demoBoxHidden, setDemoBoxHidden] = useState(true);

  const pairedContactsCount = useMemo(
    () => pairedPatients.length + pairedPhysicians.length,
    [pairedPatients, pairedPhysicians],
  );

  useEffect(() => {
    // check for support existence to make sure contacts have loaded to prevent glinting
    if (!isLoadingUserProfile && support.length && pairedContactsCount < 5) {
      setDemoBoxHidden(activity !== 'new' || demoBoxHiddenProfile || !isBasicUser);
    }
  }, [
    demoBoxHiddenProfile,
    isLoadingUserProfile,
    support,
    pairedContactsCount,
    activity,
    isBasicUser,
  ]);

  const handleHideDemoBox = event => {
    update({ demoBoxHidden: true });
    trackEvent(event);
    setDemoBoxHidden(true);
  };

  const handleDemoClick = event => {
    trackEvent(event);
    const params = new URLSearchParams();

    const paramObject = {
      zip: postalCode,
      email,
      lastname: lastName,
      company: workplace,
    };

    Object.entries(paramObject).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    const url = new URL(DEMO_BOOKING_URL);
    url.search = params.toString();

    window.open(url, '_blank', 'noreferrer, noopener');
  };

  if (!demoBoxHidden) {
    return (
      <PhysicianWelcomeScreen.DemoBox
        onClick={handleDemoClick}
        onHide={handleHideDemoBox}
        name={fullNameWithTitle}
      />
    );
  }
  return null;
};

export default DemoBox;
